import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { NavigationApp } from 'utils/map';
import { HeadingS } from '../../styles';
import { BottomSheet } from '../BottomSheet';
import { Button } from '../Button';
import type { DropdownOption } from '../Dropdown/Dropdown.types';
import { DropdownMenu } from '../Dropdown/DropdownMenu/DropdownMenu';
import { NavigationAppsBottomSheetCSS } from './NavigationAppsBottomSheet.css';

const { Title, IconCard, Footer } = NavigationAppsBottomSheetCSS;

export type NavigationAppsBottomSheetProps = {
  onSelect: (app: NavigationApp, remember: boolean) => void;
  onDismiss: () => void;
};

export const NavigationAppsBottomSheet = ({
  onSelect,
  onDismiss,
}: NavigationAppsBottomSheetProps) => {
  const { t } = useTranslation('commonUi');
  const [selectedApp, setSelectedApp] = useState<NavigationApp>('googleMaps');

  const options: DropdownOption<NavigationApp>[] = [
    {
      value: 'googleMaps',
      label: 'Google Maps',
      selected: selectedApp === 'googleMaps',
      leftIcon: (
        <IconCard>
          <img src="/images/google-maps.svg" alt="" height={20} />
        </IconCard>
      ),
    },
    {
      value: 'waze',
      label: 'Waze',
      selected: selectedApp === 'waze',
      leftIcon: (
        <IconCard>
          <img src="/images/waze.svg" alt="" width={32} height={32} />
        </IconCard>
      ),
    },
  ];

  return (
    <BottomSheet open onDismiss={onDismiss}>
      <Title>
        <HeadingS>{t('navigationApps.title')}</HeadingS>
      </Title>
      <DropdownMenu
        flat
        options={options}
        onItemClick={(option) => setSelectedApp(option.value)}
      />
      <Footer>
        <Button
          variant="transparent"
          onClick={() => onSelect(selectedApp, false)}
        >
          {t('navigationApps.once')}
        </Button>
        <Button
          variant="transparent"
          onClick={() => onSelect(selectedApp, true)}
        >
          {t('navigationApps.always')}
        </Button>
      </Footer>
    </BottomSheet>
  );
};
